import React from 'react'
import { Field } from 'formik'
import { CustomRadioField } from '../CustomRadioField'
import { CustomFieldGroup } from '../CustomFieldGroup'

export interface ICustomRadioGroup {
  name: string
  items: Array<{ value: string; label: React.ReactNode }>
  index?: number
  error?: string
  validate?: (value) => string | undefined
  validateImmediately?: boolean
  disabled?: boolean
}

export const CustomRadioGroup = ({
  name,
  items,
  index,
  error,
  validate,
  validateImmediately,
  disabled,
}: ICustomRadioGroup) => (
  <CustomFieldGroup error={error}>
    <ul>
      {items.map(({ value, label }) => {
        const id = `${value}${index !== undefined ? `-${index}` : ''}`
        return (
          <li key={id}>
            <Field
              label={label}
              id={id}
              value={value}
              name={name}
              component={CustomRadioField}
              disabled={!!disabled}
              validate={validate}
              validateImmediately={validateImmediately}
            />
          </li>
        )
      })}
    </ul>
  </CustomFieldGroup>
)
